import { createI18n } from "vue-i18n";

const getSavedLocale = () => {
  return localStorage.getItem("lang") || "pt";
};

const i18n = createI18n({
  legacy: false,
  locale: getSavedLocale(),
  fallbackLocale: "pt",
  messages: {},
});

const loadLocaleMessages = async (locale: string) => {
  if (!i18n.global.availableLocales.includes(locale)) {
    const messages: any = await import(`@/shared/config/i18n/messages/${locale}.json`);
    i18n.global.setLocaleMessage(locale, messages.default);
  }
  i18n.global.locale.value = locale;
  localStorage.setItem("lang", locale);
};

export { i18n, loadLocaleMessages };
